<script lang="ts">
    import Link from "@frontend/Components/Link.svelte";
    import { RefreshMe, TOKEN_STORAGE_KEY } from "@frontend/user";
    import { onMount } from "svelte";
     import { translate, currentLanguage } from "../Translator";
</script>

<div class="sidebar-menu">
    <div class="menu-section">
        <Link href="#/UserPerfil" class="item mini profile-link">
            <div class="icon-container">
                <i class="user circle icon"></i>
            </div>
            <span>{ $translate('Profile')}</span>
        </Link>
        <Link href="#/ReportCashier" class="item mini">
            <div class="icon-container">
                <i class="percentage icon"></i>
            </div>
            <span>{ $translate('ReportCashier')}</span>
        </Link>
        <!-- <Link href="#/Transactionperuser" class="item mini">
            <div class="icon-container">
                <i class="chartline icon"></i>
            </div>
            <span>{ $translate('Tx per user')}</span>
        </Link> -->
        <Link href="#/Transaction" class="item mini">
            <div class="icon-container">
                <i class="wallet icon"></i>
            </div>
            <span>{ $translate('Transactions')}</span>
        </Link>
        <!-- <Link href="#/SumReport" class="item mini">
            <div class="icon-container">
                <i class="calculator icon"></i>
            </div>
            <span>{ $translate('Sums')}</span>
        </Link> -->
        <Link href="#/GameRoundList" class="item mini">
            <div class="icon-container">
                <i class="history icon"></i>
            </div>
            <span>{ $translate('Rounds')}</span>
        </Link>
        <!-- <Link href="#/GameServerList" class="item mini">
            <div class="icon-container">
                <i class="server icon"></i>
            </div>
            <span>Game Servers</span>
        </Link> -->
        <!-- <Link href="#/GamesList" class="item mini">
            <div class="icon-container">
                <i class="chess icon"></i>
            </div>
            <span>{ $translate('Games')}</span>
        </Link> -->
        <!-- <Link href="#/AdminList" class="item mini">
            <div class="icon-container">
                <i class="user icon"></i>
            </div>
            <span>Administrators</span>
        </Link> -->
        <!-- <Link href="#/CashierList" class="item mini">
            <div class="icon-container">
                <i class="user icon"></i>
            </div>
            <span>{ $translate('Cashiers')}</span>
        </Link> -->
        <Link href="#/PlayerList" class="item mini">
            <div class="icon-container">
                <i class="user friends icon"></i>
            </div>
            <span>{ $translate('Players')}</span>
        </Link>
        <!-- <Link href="#/Groups" class="item mini">
            <div class="icon-container">
                <i class="users icon"></i>
            </div>
            <span>Games Groups</span>
        </Link> -->
        <!-- <Link href="#/GroupList" class="item mini">
            <div class="icon-container">
                <i class="users icon"></i>
            </div>
            <span>{ $translate('User Groups')}</span>
        </Link> -->
        <Link href="#/user/logout" class="item mini">
            <div class="icon-container">
                <i class="lock icon"></i>
            </div>
            <span>{ $translate('Logout')}</span>
        </Link>
    </div>
</div>

<style>
    .sidebar-menu {
        display: flex;
        flex-direction: column;
        height: auto;
        min-height: 100vh;
        padding-bottom: 1rem;
        overflow-y: auto;
        overflow-x: hidden;
        position: relative;
        padding-top: 60px; /* Space for the absolute positioned profile */
    }

    .menu-section {
        padding: 0.25rem 0;
        border-bottom: 1px solid rgba(255,255,255,0.1);
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 0.1rem;
        position: relative;
    }

    .menu-section:last-child {
        border-bottom: none;
    }


    :global(.item.mini) {
        padding: 0.5rem 1rem !important;
        font-size: 0.9em !important;
        display: flex !important;
        align-items: center !important;
    }

    :global(.icon-container) {
        width: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0.5rem;
    }

    :global(.item.mini i.icon) {
        margin: 0 !important;
    }

    :global(.item.mini:hover) {
        background-color: rgba(255,255,255,0.1) !important;
    }

    :global(.item.mini span) {
        flex: 1;
    }

    /* Ensure profile option is always visible */
    :global(.item.mini[href="#/UserPerfil"]) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        z-index: 10 !important;
    }

    /* Force profile visibility on desktop */
    @media (min-width: 769px) {
        :global(.item.mini[href="#/UserPerfil"]) {
            display: flex !important;
            visibility: visible !important;
            opacity: 1 !important;
            height: auto !important;
            overflow: visible !important;
        }
    }

    /* Additional forced styles for profile */
    :global(.sidebar-menu .item.mini[href="#/UserPerfil"]) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
    }

    :global(.menu-section .item.mini[href="#/UserPerfil"]) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
    }

    /* SUPER AGGRESSIVE profile visibility - highest priority */
    :global(.toc .ui.vertical.labeled.icon.menu .sidebar-menu .item.mini[href="#/UserPerfil"]) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        z-index: 999 !important;
        height: auto !important;
        overflow: visible !important;
        background-color: rgba(255,255,255,0.1) !important;
    }

    :global(.toc .ui.vertical.labeled.icon.menu .menu-section .item.mini[href="#/UserPerfil"]) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        z-index: 999 !important;
        height: auto !important;
        overflow: visible !important;
        background-color: rgba(13, 13, 13, 0.1) !important;
    }

    /* Force ALL profile links to be visible regardless of parent */
    :global([href="#/UserPerfil"]) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        z-index: 999 !important;
        height: auto !important;
        overflow: visible !important;
        background-color: rgba(255,255,255,0.1) !important;
    }

    /* ULTRA AGGRESSIVE profile visibility using global selectors */
    :global(.profile-link) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        z-index: 9999 !important;
        height: auto !important;
        overflow: visible !important;
        background-color: #1b1c1d !important;
        color: white !important;
        border: none !important;
        margin: 0 !important;
        padding: 0.5rem !important;
        border-radius: 5px !important;
        font-weight: bold !important;
        text-decoration: none !important;
    }

    /* Force profile-link to be visible in all contexts */
    :global(.item.mini.profile-link) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        z-index: 9999 !important;
        height: auto !important;
        overflow: visible !important;
        background-color: #1b1c1d !important;
        color: white !important;
        border: none !important;
        margin: 0 !important;
        padding: 0.5rem !important;
        border-radius: 5px !important;
        font-weight: bold !important;
        text-decoration: none !important;
    }

    /* Ensure profile is always the first visible element */
    :global(.menu-section .item.mini:first-child) {
        position: sticky !important;
        top: 0 !important;
        z-index: 9999 !important;
        background-color: #1b1c1d !important;
        padding-top: 0.5rem !important;
    }

    /* Ensure normal menu items flow properly */
    :global(.item.mini:not(.profile-link)) {
        margin-bottom: 0.1rem !important;
        padding: 0.5rem !important;
    }

    /* Ensure last menu item has extra space */
    .menu-section:last-child {
        padding-bottom: 0.5rem !important;
    }

    /* Desktop specific styles */
    @media (min-width: 769px) {
        :global(.profile-link) {
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            z-index: 9999 !important;
            background-color: #1b1c1d !important;
            color: white !important;
            border: none !important;
            margin: 0 !important;
            padding: 0.5rem !important;
            border-radius: 5px !important;
            font-weight: bold !important;
            text-decoration: none !important;
            display: flex !important;
            visibility: visible !important;
            opacity: 1 !important;
        }

        .sidebar-menu {
            padding-top: 60px !important;
        }
    }
</style>
